import React, { useContext, useEffect, useState } from 'react';
import { Container, Typography } from '@material-ui/core';
import useStyles from './TrialReminder.styles';
import { messages } from './TrialReminder.messages';
import { FormattedMessage } from 'react-intl';
import { AuthContext } from '../../../common/authContext';
import { DateTime } from 'luxon';
const MAX_CLIENTS_WARNING = 40;
const MAX_CLIENTS = 50;

export default function TrialReminder({
  reminderType
}: {
  reminderType: 'expiration' | 'clients';
}) {
  const { authUser, clientsCreated } = useContext(AuthContext);
  const [daysLeft, setDaysLeft] = useState(0);
  const [
    showTrialExpirationReminder,
    setShowTrialExpirationReminder
  ] = useState(false);
  const [showTrialClientsReminder, setShowTrialClientsReminder] = useState(
    false
  );
  const styles = useStyles();

  useEffect(() => {
    if (authUser && authUser.status === 'trial') {
      if (reminderType === 'expiration' && authUser.trialEndsAt) {
        const today = DateTime.now();
        const trialEndsAt = DateTime.fromJSDate(new Date(authUser.trialEndsAt));
        const calculatedDaysLeft = Math.ceil(
          trialEndsAt.diff(today, 'days').days
        );
        setDaysLeft(calculatedDaysLeft);
        if (
          authUser.status === 'trial' &&
          reminderType === 'expiration' &&
          calculatedDaysLeft > 0 &&
          calculatedDaysLeft <= 75
        ) {
          setShowTrialExpirationReminder(true);
        }
      }
      if (reminderType === 'clients' && clientsCreated >= MAX_CLIENTS_WARNING) {
        setShowTrialClientsReminder(true);
      }
    }
  }, [authUser, reminderType, clientsCreated]);

  if (!showTrialExpirationReminder && !showTrialClientsReminder) {
    return null;
  }

  return (
    <>
      <Container
        className={styles.bannerContainer}
        maxWidth="xl"
        component="div"
      >
        <Typography variant="h5" align="center">
          {showTrialExpirationReminder && (
            <FormattedMessage
              {...messages.trialEndsReminder}
              values={{ daysLeft }}
            />
          )}
          {showTrialClientsReminder && (
            <FormattedMessage
              {...messages.trialClientsReminder}
              values={{ clientsCreated, maxClients: MAX_CLIENTS }}
            />
          )}
        </Typography>
      </Container>
    </>
  );
}
